import { z } from 'zod';
import { clientTypeSchema } from '../mcp';
import { securityIssueSchema } from '../scans';
import { decisionPlanSchema } from './decisions';
// POST /api/scans/reference (KIR-4631 / KIR-2757 worktree dedup fan-out).
//
// When the agent re-encounters content it has already scanned this session (a
// git-worktree / submodule-overlay / vendored duplicate), it sends a tiny
// content-FREE reference instead of re-uploading + re-scanning: the backend
// looks up the prior finding for that content (org-scoped, context-matched),
// records this path as an occurrence, and returns the finding + the
// enforcement decision so the agent enforces THIS copy — with no detectors /
// Kirin AI / DLP. A backend miss (content never scanned in this org, or reaped)
// tells the agent to fall back to a full scan.
export const scanReferenceRequestSchema = z.object({
    clientVersion: z.string().optional(),
    // SHA-256 of the content the agent already hashed for its stat-gate.
    contentHash: z.string(),
    // Detection is fileType/path-gated, so the reference carries the same context
    // the dedup key used — the backend reuses a finding only when it matches.
    fileType: z.string(),
    relativePath: z.string().optional(),
    fileRoot: z.string().optional(),
    // The machine-local path that IS this occurrence, + the machine identity.
    absolutePath: z.string(),
    machineId: z.string(),
});
export const scanReferenceResponseSchema = z.discriminatedUnion('status', [
    // Hit: reuse the prior finding + decision; the occurrence has been recorded.
    z.object({
        status: z.literal('hit'),
        issues: z.array(securityIssueSchema),
        plan: decisionPlanSchema,
        // KIR-4646: same meaning as `attributedPlatform` on POST /api/scans — the
        // owner of this path when it is not the reporting client.
        attributedPlatform: clientTypeSchema.optional(),
    }),
    // Miss: no matching prior finding for this org+content+context → full-scan.
    z.object({
        status: z.literal('miss'),
    }),
]);
//# sourceMappingURL=scan-reference.js.map